import React, { FC } from 'react';
import { t, Trans } from '@lingui/macro';

import { Box, Button, Heading, Paragraph } from '@rover/kibble/core';
import BottomSheet from '@rover/kibble/official-patterns/BottomSheet';
import {
  EXPLANATION_MODAL_BUTTON_TEXT,
  EXPLANATION_MODAL_HEADER,
  EXPLANATION_MODAL_INITIAL_PARAGRAPH,
} from '@rover/react-lib/src/pages/search/SearchPage/components/Modals/BestMatchExplanationModal/constants';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const BestMatchExplanationBottomSheet: FC<Props> = ({ isOpen, onClose }) => {
  return (
    <BottomSheet
      height={520}
      isOpen={isOpen}
      onRequestClose={onClose}
      hideCloseIcon
      isDismissible
      closeOnDragDown
    >
      <Box>
        <Heading size="300" fontWeight="semibold">
          {EXPLANATION_MODAL_HEADER()}
        </Heading>
        <Paragraph>{EXPLANATION_MODAL_INITIAL_PARAGRAPH()}</Paragraph>
        <Paragraph mb="6x">
          <Trans>
            All pet care providers who sign up on Rover pass{' '}
            <a
              href="/background-checks"
              target="_blank"
              aria-label={t`Learn more about the background check process`}
            >
              a background check
            </a>
            <span aria-hidden="true">.</span>
          </Trans>
        </Paragraph>
        <Button circular variant="primary" onClick={onClose} fullWidth>
          {EXPLANATION_MODAL_BUTTON_TEXT()}
        </Button>
      </Box>
    </BottomSheet>
  );
};

export default BestMatchExplanationBottomSheet;
